import { DocumentTypeId } from './enums/document-type.enum'
import {
  CPF_NUMBER_REGEX,
  CPF_NUMBER_VALIDATION_REGEX,
  REGISTRATION_NUMBER_REGEX,
  REGISTRATION_NUMBER_VALIDATION_REGEX,
  RG_NUMBER_REGEX,
  RG_NUMBER_VALIDATION_REGEX,
} from './regex.util'
import { isCpf } from 'utils/validate.util'

type DocumentDetails = {
  regex: RegExp
  regexValidation: RegExp
  mask: string
  isValid: (value: string) => boolean
}

const REGISTRATION_NUMBER_PLACE_MASK = '$1.$2/$3-$4'
const CPF_NUMBER_PLACE_MASK = '$1.$2.$3-$4'
const RG_NUMBER_PLACE_MASK = '$1.$2.$3-$4'

export const DOCUMENT_TYPE_MASKS: Record<string, DocumentDetails> = {
  [DocumentTypeId.CERTIDAO_DE_NASCIMENTO]: {
    regex: REGISTRATION_NUMBER_REGEX,
    regexValidation: REGISTRATION_NUMBER_VALIDATION_REGEX,
    mask: REGISTRATION_NUMBER_PLACE_MASK,
    isValid: (value: string) => REGISTRATION_NUMBER_VALIDATION_REGEX.test(value),
  },
  [DocumentTypeId.CERTIDAO_DE_CASAMENTO]: {
    regex: REGISTRATION_NUMBER_REGEX,
    regexValidation: REGISTRATION_NUMBER_VALIDATION_REGEX,
    mask: REGISTRATION_NUMBER_PLACE_MASK,
    isValid: (value: string) => REGISTRATION_NUMBER_VALIDATION_REGEX.test(value),
  },
  [DocumentTypeId.CERTIDAO_DE_OBITO]: {
    regex: REGISTRATION_NUMBER_REGEX,
    regexValidation: REGISTRATION_NUMBER_VALIDATION_REGEX,
    mask: REGISTRATION_NUMBER_PLACE_MASK,
    isValid: (value: string) => REGISTRATION_NUMBER_VALIDATION_REGEX.test(value),
  },
  [DocumentTypeId.CPF]: {
    regex: CPF_NUMBER_REGEX,
    regexValidation: CPF_NUMBER_VALIDATION_REGEX,
    mask: CPF_NUMBER_PLACE_MASK,
    isValid: (cpf: string) => isCpf(cpf),
  },
  [DocumentTypeId.IDENTIDADE_CIVIL]: {
    regex: RG_NUMBER_REGEX,
    regexValidation: RG_NUMBER_VALIDATION_REGEX,
    mask: RG_NUMBER_PLACE_MASK,
    isValid: (value: string) => RG_NUMBER_VALIDATION_REGEX.test(value),
  },
}

export const formatBytes = (bytes: number): string => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) return '0 Byte'
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10)
  return Math.round((bytes / Math.pow(1024, i)) * 100) / 100 + ' ' + sizes[i]
}

export const extractFileExtension = (fileName: string): string =>
  (fileName && fileName.split('.').pop()) || ''

export const extractFileSize = (file: File): string => formatBytes(file.size)

export const isDocumentFormatValid = (typeId: string, documentNumber: string): boolean => {
  const documentDetails = DOCUMENT_TYPE_MASKS[typeId]
  let isValid = true
  if (documentDetails) {
    isValid = documentDetails.isValid(documentNumber)
  }
  return isValid
}
